module.exports = __webpack_public_path__ + "img/logo-france.124f4d7e.png";